"use client"

import { Facebook, Twitter, Linkedin, ArrowRight, PhoneCall, Mail } from 'lucide-react'
import { motion } from "framer-motion"

const usefulLinks = [
  { title: "About Us", href: "/about-us" },
  { title: "Contact Us", href: "/contact-us" },
]

const socialLinks = [
  { icon: Facebook, href: "https://www.facebook.com/profile.php?id=61574788103320" },
  { icon: Twitter, href: "https://x.com/InterPetro" },
  { icon: Linkedin, href: "https://www.linkedin.com/in/ali-shamim-06b74033a/" },
]

export function Footer() {
  return (
    <footer className="relative before:absolute before:inset-0 bg-[#ffffffab] before:z-[-1] before:bg-[url('/public/images/footer.jpg')] before:bg-cover before:bg-no-repeat text-white">
      <div className="container mx-auto px-4 py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="space-y-4"
          >
            <a href="/" className="flex items-center h-12 w-56">
              <img alt="logo"
                src="/images/INTERPETRO_LOGO.png"
                className="size-full object-contain"
              />
            </a>
            <p className="text-[#001031] text-sm text-left">
              Delivering specialty chemicals and formulations with logistics support and technical expertise for manufacturers in diverse sectors globally.
            </p>

            <div className="flex items-center space-x-2 text-[#091e27]">
              <a href="tel:+23525521215" className="flex items-center space-x-2">
                <PhoneCall />
                <span>+971 56 166 8746</span>
              </a>
            </div>
            <div className="flex items-center space-x-2 text-[#001031]">
              <a href="mailto:info@interpetro-chem.com" className="flex items-center space-x-2">
                <Mail />
                <span>info@interpetro-chem.com</span>
              </a>
            </div>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.1 }}
          >
            <h3 className="text-lg font-semibold mb-4 text-left text-[#001031]">Useful Links</h3>
            <ul className="space-y-2">
              {usefulLinks.map((link) => (
                <li key={link.title}>
                  <a
                    href={link.href}
                    className="text-[#001031] hover:text-[#0d2a35] transition-colors flex items-center gap-2 text-left"
                  >
                    <ArrowRight className="w-4 h-4" />
                    {link.title}
                  </a>
                </li>
              ))}
            </ul>
          </motion.div>

          {/* Newsletter */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.3 }}
          >
            <div className="space-y-4">
              <p className="text-lg font-semibold text-left text-[#001031]">Follow Us</p>
              <div className="flex gap-4">
                {socialLinks.map((link, index) => {
                  const Icon = link.icon
                  return (
                    <a
                      key={index}
                      href={link.href}
                      className="text-[#001031] hover:text-[#153d4c] transition-colors text-left"
                    >
                      <Icon className="w-5 h-5" />
                    </a>
                  )
                })}
              </div>
            </div>
          </motion.div>
        </div>
        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-center items-center gap-4">
          <p className="text-[#001031] text-sm">
            © INTERPETRO. All Rights Reserved by the site
          </p>
        </div>
      </div>
    </footer>
  )
}
